import { Icon } from './Icon.jsx';
import './dsFocus.js';

/**
 * SelectNative — a DS-skinned NATIVE <select>: appearance:none, radius 10, hairline
 * ring, the control tier (32 / 28 with `compact`) and a caret-down glyph laid over the
 * control. The <option> list is passed as children and every native handler stays
 * native.
 *
 * Named SelectNative, not Select (spec D1): the skill's `Select` is a different
 * contract — a presentational trigger with "wire your own menu" (Select.d.ts:4, no
 * onChange, no children). Claiming that name for an incompatible contract would also
 * put every call site in violation of the adherence prop allowlist for `Select`.
 * Keeping the native element is spec S7 / A7: replacing it would change keyboard,
 * mobile and option semantics — a functional change, which F3 forbids.
 */
export function SelectNative ({ value, onChange, children, disabled = false, compact = false, className, ...rest }) {
  return (
    <span className={['oc-select', compact && 'oc-select--compact', className].filter(Boolean).join(' ')}>
      <select
        className="oc-select__control"
        value={value}
        onChange={onChange}
        disabled={disabled}
        data-ds-focusable
        {...rest}
      >
        {children}
      </select>
      <Icon name="caret-down" size="sm" className="oc-select__caret" />
    </span>
  );
}
